import { useContext, useState } from "react";
import { useCreateSenderId } from "../../../../hooks/api/mutations/usePlatformCredit";
import { ToastContext } from "../../../../hooks/context";

export const useSmsSenderIdForm = ({ closeModal = () => {} }) => {
  const triggerToast = useContext(ToastContext);
  const [formData, setFormData] = useState({ sender_id: "" });

  const { mutate: createSenderId, isLoading } = useCreateSenderId();
  const handleCreateID = () => {
    createSenderId(formData, {
      onSuccess: () => {
        triggerToast(
          "Sender ID created, this might take up to 24hrs to get approved!",
          "success",
        );
        closeModal();
      },
    });
  };

  return { isLoading, formData, setFormData, handleCreateID };
};
